import { Crown, Zap } from 'lucide-react';

/**
 * Single source of truth for VIP tier metadata + registration form options.
 * Imported by both VIPSection and its modal form.
 */

export const TIER_META = {
  part_time: {
    label: 'Part-Time',
    monthly: 15,
    regular: 540,
    vip: 54,
    total: 75,
    tagline: 'For side-hustle resellers doing this regularly',
    perks: [
      'Full 4-buyer price comparison',
      'Barcode scanning (offline-capable PWA)',
      'Priority support',
      'First access to new features',
      'Founding 100 community channel',
      'Founding Member badge',
    ],
    icon: Zap,
  },
  full_time: {
    label: 'Full-Time',
    monthly: 30,
    regular: 1080,
    vip: 108,
    total: 25,
    tagline: 'For bulk flippers and resale businesses — our primary market',
    perks: [
      'Everything in Part-Time, plus:',
      'Priority API quota',
      'Advanced cross-buyer arbitrage alerts',
      'Unlimited batch price checking',
      'Direct line to the founder',
      'First to ship: OCR screenshot extraction',
    ],
    icon: Crown,
  },
};

export const STATUS_OPTIONS = [
  { value: 'hobbyist', label: 'Home Collection (few items here and there)' },
  { value: 'part_time_reseller', label: 'Part-time reseller (regular side hustle)' },
  { value: 'full_time_reseller', label: 'Full-time reseller (my main income)' },
  { value: 'business', label: 'Business (house clearance / bulk operation)' },
];
